import { InlineText1 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { Link } from '../../../common/Link';

interface IBetLeadersTitleProps {
  isMobile: boolean;
  serpUrl: string | undefined;
  onLinkClick(): void;
}

export const BetLeadersTitle = ({ isMobile, serpUrl, onLinkClick }: IBetLeadersTitleProps) => {
  const titleFontWeight = isMobile ? 'normal' : '700';

  return (
    <InlineText1 fontWeight={titleFontWeight}>
      Ставки лидеров{' '}
      <Link href={serpUrl} target="_blank" onClick={onLinkClick}>
        в поиске по району
      </Link>
    </InlineText1>
  );
};
